<template>
    <v-overlay :model-value="loading" class="align-center justify-center" persistent>
        <v-progress-circular color="amber" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Image used -->
    <img src="@/assets/classroom2.jpg" class="img-fluid formBanner" alt="Ask Us Banner">

    <div class="container formContainer mt-md-auto p-5 col-md-6 isForm">

        <!-- Form Details -->
        <p id="askUsFormHeader">GET IN TOUCH WITH US</p>
        <form class="row g-2" @submit.prevent="submitForm">
            <div class="mb-1">
                <!-- Full Name -->
                <label for="inquirerFullName" class="form-label">Full Name</label>
                <input type="text" class="form-control" id="inquirerFullName" placeholder="Full Name" name="fullName"
                    v-model="emailFormData.fullName" @input="emailForm$.fullName.$touch">
                <div v-if="emailForm$.fullName.$errors[0]" class="alert alert-danger m-0 p-1">
                    <em> {{ emailForm$.fullName.$errors[0].$message }}</em>
                </div>
            </div>
            <!-- Email -->
            <div class="mb-1">
                <label for="inquirerEmailAddress" class="form-label">E-mail Address</label>
                <input type="text" class="form-control" id="inquirerEmailAddress" placeholder="E-mail Address" name="email"
                    v-model="emailFormData.email" @input="emailForm$.email.$touch">
                <div v-if="emailForm$.email.$errors[0]" class="alert alert-danger m-0 p-1">
                    <em> {{ emailForm$.email.$errors[0].$message }}</em>
                </div>
            </div>
            <!-- Contact Number -->
            <div class="mb-1">
                <label for="inquirerContactNumber" class="form-label">Contact Number</label>
                <input type="text" class="form-control" id="inquirerContactNumber" placeholder="Contact Number"
                    name="contactNumber" v-model="emailFormData.contactNumber" @input="emailForm$.contactNumber.$touch">
                <div v-if="emailForm$.contactNumber.$errors[0]" class="alert alert-danger m-0 p-1">
                    <em> {{ emailForm$.contactNumber.$errors[0].$message }}</em>
                </div>
            </div>
            <!-- Subject -->
            <div class="mb-1">
                <label for="inquirerSubject" class="form-label">Subject</label>
                <input type="text" class="form-control" id="inquirerSubject" placeholder="Subject" name="subject"
                    v-model="emailFormData.subject" @input="emailForm$.subject.$touch">
                <div v-if="emailForm$.subject.$errors[0]" class="alert alert-danger m-0 p-1">
                    <em> {{ emailForm$.subject.$errors[0].$message }}</em>
                </div>
            </div>
            <!-- Concern -->
            <div class="form-group">
                <label for="inquirerConcern">Concern</label>
                <textarea class="form-control" id="inquirerConcern" rows="3" name="message" v-model="emailFormData.message"
                    placeholder="Concern" @input="emailForm$.message.$touch"></textarea>
                <div v-if="emailForm$.message.$errors[0]" class="alert alert-danger m-0 p-1">
                    <em> {{ emailForm$.message.$errors[0].$message }}</em>
                </div>
            </div>
            <div class="col-12">
                <button type="submit" id="submitInquiryButton">Submit Inquiry</button>
            </div>
        </form>
    </div>
</template>


<style scoped src="@/assets/css/globalStyle.css"></style>

<style scoped>
button:active {
    transform: scale(0.68);
}

#askUsFormHeader {
    font-family: 'DK Frozen';
    font-size: 3em;
    color: #FEC93C;
    text-shadow: 2px 2px #ffffff;
    text-align: center;
}

#submitInquiryButton {
    float: right;
}

.formContainer {
    background-color: #2F437A;
    color: white;
    font-family: dosis;
    border-radius: 21px;
    position: relative;
    top: 450px;
}

.form-label {
    color: white;
}

.formBanner {
    position: absolute;
}

@media (max-width: 768px) {
    .formContainer {
        background-color: #2F437A;
        color: white;
        font-family: dosis;
        border-radius: 21px;
        position: relative;
        top: 170px;
    }

    .formBanner {
        position: absolute;
    }
}
</style>

<script>
// Dependencies
import { reactive, ref } from 'vue';
import emailjs from 'emailjs-com';
import useVuelidate from '@vuelidate/core';
import { required, helpers, email, maxLength } from '@vuelidate/validators';

export default {
    setup() {

        // Form data
        const emailFormData = reactive({
            fullName: "",
            email: "",
            contactNumber: "",
            subject: "",
            message: ""
        });

        // Regex for contact number
        const validContactNumber = (contactNumber) => {
            const regex = /^[0][9][0-9]{9}$/;
            return regex.test(contactNumber);
        }

        const loading = ref(false);

        // Vuelidate rules
        const emailFormRules = {
            fullName: { required, maxLength: maxLength(300) },
            email: { required, email, maxLength: maxLength(254) },
            contactNumber: { required, validContactNumber: helpers.withMessage("Invalid Contact Number (Example: 09123456789)", validContactNumber) },
            subject: { required, maxLength: maxLength(100) },
            message: { required, maxLength: maxLength(63206) }
        }

        // Vuelidate init
        const emailForm$ = useVuelidate(emailFormRules, emailFormData);

        // Submitting of Form to database
        const submitForm = async (e) => {
            loading.value = true;
            // Validate that all fields are filled up
            const result = await emailForm$.value.$validate();

            if (result) {
                // Reset form
                emailForm$.value.$reset();
                try {

                    // Send Email to organization via emailjs
                    await emailjs.sendForm(process.env.VUE_APP_SERVICE_ID, process.env.VUE_APP_TEMPLATE_ID, e.target,
                        process.env.VUE_APP_USER_ID, {
                        subject: emailFormData.subject,
                        message: emailFormData.message,
                        contactNumber: emailFormData.contactNumber,
                        fullName: emailFormData.fullName,
                        email: emailFormData.email

                    }).then(function (response) {
                        // Alert user that email was sent succesfully, reset the field
                        console.log('Successfully Sent Email!', response.status, response.text);
                        alert("Email Sent Successfully");
                        // Remove fields
                        emailFormData.fullName = "";
                        emailFormData.email = "";
                        emailFormData.contactNumber = "";
                        emailFormData.subject = "";
                        emailFormData.message = "";
                    }, function (error) {
                        // Email not sent successfully
                        console.log('FAILED...', error);
                        alert("Failed to send Email");
                    });

                }
                catch (error) {
                    // Alert email not sent
                    alert("ERROR: Email not sent");
                    console.log(error);
                }
            } else {
                alert("Please check the form for errors")
            }

            loading.value = false;
        }

        return {
            emailFormData,
            emailForm$,
            submitForm,
            loading
        }
    },
}

</script>